import React, { useState } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import Select from "react-select";

const customStyles = {
    menu: (provided, state) => ({
        ...provided,
        backgroundColor: "#fff",
        position: "relative",
        top: "3px",
        left: "0px",
        width: "100%",
        maxWidth: "100%",
        color: "#000"
    }),
    option: (provided, state) => ({
        ...provided,
        marginBottom: "5px",
        backgroundColor: "transparent",
        maxWidth: "356px",
        color: "#fff",
        borderBottom: "#fff",
        "&:hover": {
            transition: "all 0.5s ease",
            color: "#e50914"
        },
        "&:active": {
            transition: "all 0.5s ease",
            color: "#000"
        }
    }),
    control: (provided, state) => ({
        ...provided,
        border: "1px solid transparent",
        boxShadow: "0px 0px",
        "&:hover": {
            border: "1px solid transparent",
            boxShadow: "0px 0px",
        },
        "&:focus": {
            border: "1px solid transparent"
        }
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        border: "1px solid transparent"
    })
}

const AddNewUserModal = (props) => {
    const { onChangeAdd, SetPackName, PackDetails, AdminUserAddPlans } = props

    const [addnewuser, setAddnewuser] = useState(true)

    return (
        <div className='modals'>
            <Modal
                onHide={() => { props.onDismiss() }}
                show={addnewuser}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton onClick={() => props.onDismiss()}>
                    <Modal.Title>Add New User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='newthememodal'>
                       <div className=''>
                        <Row>
                            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12} className='mt-3'>
                                <input type="text" id="Address" className='edit_inputs_align' placeholder='wallet Address*' name="wallet address" onChange={(e) => onChangeAdd(e)}
                                />
                            </Col>
                            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12} className='mt-3'>
                                <Select
                                    // menuIsOpen={true}
                                    className="yes1 form-control primary_inp select1 selxet_app h-40 p-0"
                                    onChange={(e) => SetPackName(e.value)}
                                    options={PackDetails}
                                    label="Single select"
                                    isSearchable={false}
                                    styles={customStyles}
                                    classNamePrefix="react-select"
                                    formControlProps={{
                                        fullWidth: true,
                                    }}
                                />
                            </Col>
                            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12} className='mt-3'>
                                <input type="text" id="Quantity" className='edit_inputs_align' placeholder='Enter Quantity*' name="wallet address" onChange={(e) => onChangeAdd(e)} />
                            </Col>
                        </Row>
                        <div className='adm_mdl_add_btn mt-3 mb-4 text-end'>
                            <button color="primary" type="submit" className="admin_mdl_red_btn" onClick={() => AdminUserAddPlans()}>Add</button>
                        </div>
                        </div>
                        <div class="container-fluid edit_table_container_align">
                            <div class="table-responsive" style={{ position: "relative", zIndex: 0 }}>
                                <table class="table edit_user_table_align">
                                    <thead>
                                        <tr>
                                            <th scope="col">Module Permission</th>
                                            <th scope="col">LazyMint ERC 721 & ERC 1155</th>
                                            <th scope="col">Bulk LazyMint</th>
                                            <th scope="col">SoulBound Tokens</th>
                                            <th scope="col">Token Scanner</th>
                                            <th scope="col">Dashboard And Profile</th>
                                            <th scope="col">Campaign Page</th>
                                        </tr>
                                    </thead>
                                    {PackDetails && PackDetails.length > 0 && PackDetails.map((item, index) => {
                                        return (
                                            <tbody>
                                                <tr>
                                                    <td className='lft_frst_td' scope="row">{item.PackName}</td>
                                                    {item.ERC == "true" ?
                                                        <td><input type="checkbox" className='table_check_align' id="ERC" name="ERC" value="ERC" checked="checked" /></td>
                                                        :
                                                        <td><input type="checkbox" className='table_check_align' id="ERC" name="ERC" value="ERC" disabled /></td>

                                                    }
                                                    {item.Bulkminting == "true" ?
                                                        <td><input type="checkbox" className='table_check_align' id="SoulBound" name="SoulBound" value="SoulBound" checked="checked" /></td>
                                                        :
                                                        <td><input type="checkbox" className='table_check_align' id="SoulBound" name="SoulBound" value="SoulBound" disabled /></td>
                                                    }
                                                    {item.Soulbound == "true" ?
                                                        <td><input type="checkbox" className='table_check_align' id="TokenGating" name="TokenGating" value="TokenGating" checked="checked" /></td>
                                                        :
                                                        <td><input type="checkbox" className='table_check_align' id="TokenGating" name="TokenGating" value="TokenGating" disabled /></td>
                                                    }
                                                    {item.TokenScanner == "true" ?
                                                        <td><input type="checkbox" className='table_check_align' id="TokenScanner" name="TokenScanner" value="TokenScanner" checked="checked" /></td>
                                                        :
                                                        <td><input type="checkbox" className='table_check_align' id="TokenScanner" name="TokenScanner" value="TokenScanner" disabled /></td>
                                                    }
                                                    {item.DashBoardAndProfile == "true" ?
                                                        <td><input type="checkbox" className='table_check_align' id="DashBoardAndProfile" name="DashBoardAndProfile" value="DashBoardAndProfile" checked="checked" /></td>
                                                        :

                                                        <td><input type="checkbox" className='table_check_align' id="DashBoardAndProfile" name="DashBoardAndProfile" value="DashBoardAndProfile" disabled /></td>
                                                    }
                                                    {item.DomainCampaign == "true" ?
                                                        <td><input type="checkbox" className='table_check_align' id="DomainCampaign" name="DomainCampaign" value="DomainCampaign" checked="checked" /></td>
                                                        :

                                                        <td><input type="checkbox" className='table_check_align' id="DomainCampaign" name="DomainCampaign" value="DomainCampaign" disabled /></td>
                                                    }

                                                </tr >
                                            </tbody >
                                        )
                                    })}

                                </table >
                            </div >

                        </div >
                    </div >
                </Modal.Body>

            </Modal>

        </div>
    )
}

export default AddNewUserModal